module.exports = __webpack_public_path__ + "static/media/bg_finger.87a4122c.svg";